// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__3fYI0","modalCard":"styles_modalCard__3akFV","closeModal":"styles_closeModal__2nHeY","modalContent":"styles_modalContent__edU6W"};